import axios from "axios";
import { printLogs } from "../utils/Utilities";
import { appToken, userData } from "../utils/constants";
import { getFromLocalStorage } from "../utils/localStorageUtils";
import { setLogout } from "../store/reducers/auth";

const getData = (url, method, reqData) => {
    let apiUrl = process.env.REACT_APP_API_URL + url;

    if (url.includes('foreepay')) {
        apiUrl = apiUrl.replace('/api/', '/');
    }
    else if (url.includes('xpay')) {
        apiUrl = apiUrl.replace('/api/', '/');
    }

    const token = getFromLocalStorage(appToken);

    const tokenData = getFromLocalStorage(userData);

    const headers = {
        "Content-Type": "application/json",
        "Outlet-Session-Token": token,
        Authorization: `Bearer ${tokenData?.token}`
    };


    // printLogs('API CALL', { apiUrl, method, headers, req: JSON.stringify(reqData) });

    let config = {
        method,
        url: apiUrl,
        headers,
    };

    // printLogs('url = ' + url , {config, reqData});

    if (["POST", "PATCH", "DELETE"].includes(method)) {
        config.data = JSON.stringify(reqData);
    } else if (method === "GET") {
        config.params = reqData;
    }

    return config;
};

// Function for POST requests
export const callPostWebservice = (url, reqData, responseHandler, errorHandler = null, dispatch, navigate) => {
    let config = getData(url, "POST", reqData);

    axios(config)
        .then((res) => {
            let data = res.data;
            responseHandler(data);
        })
        .catch((err) => {
            handleApiError(
                err,
                errorHandler,
                dispatch, navigate
            );
        });
};

// Function for GET requests
export const callGetWebservice = (url, reqData, responseHandler, errorHandler = null, dispatch, navigate) => {
    let config = getData(url, "GET", reqData);

    axios(config)
        .then((res) => {
            let data = res.data;
            // printLogs("RESPONSE RECEIVED", { response: JSON.stringify(data) });
            responseHandler(data);
        })
        .catch((err) => {
            handleApiError(
                err,
                errorHandler,
                dispatch, navigate
            );
        });
};

// Function for DELETE requests
export const callDeleteWebservice = (url, reqData, responseHandler, errorHandler = null, dispatch, navigate) => {
    let config = getData(url, "DELETE", reqData);

    axios(config)
        .then((res) => {
            let data = res.data;
            // printLogs("RESPONSE RECEIVED", { response: JSON.stringify(data) });
            responseHandler(data);
        })
        .catch((err) => {
            handleApiError(
                err,
                errorHandler,
                dispatch, navigate
            );
        });
};

// Function for downloading files (returns Blob)
export const callDownloadWebservice = async (url, reqData, fileName, responseHandler, errorHandler = null, dispatch, navigate) => {
    let config = getData(url, "POST", reqData);
    config.responseType = 'blob'; // Critical for binary files
    config.headers = { ...config.headers, Accept: "application/pdf" };

    try {
        const response = await axios(config);
        
        const blob = new Blob([response.data], {
            type: "application/pdf",
        });

        const blobUrl = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = fileName;

        document.body.appendChild(a);
        a.click();
        a.remove();

        window.URL.revokeObjectURL(blobUrl);
        
        if (responseHandler) responseHandler();
    } catch (err) {
        handleApiError(
            err,
            errorHandler,
            dispatch, navigate
        );
    }
};

// Function for PATCH requests
export const callPatchWebservice = (url, reqData, responseHandler, errorHandler = null, dispatch, navigate) => {
    let config = getData(url, "PATCH", reqData);

    axios(config)
        .then((res) => {
            let data = res.data;
            // printLogs("RESPONSE RECEIVED", { response: JSON.stringify(data) });
            responseHandler(data);
        })
        .catch((err) => {
            handleApiError(
                err,
                errorHandler,
                dispatch, navigate
            );
        });
};



// Helper function to handle errors
const handleApiError = (err, errorHandler, dispatch, navigate) => {

    printLogs("API ERROR", err);

    let errMessage = err.response?.data.message || err.response?.data.error || err.message || "Request failed"

    let errorData = {
        errMessage
    };

    if (errMessage === 'Unauthenticated.') {
        alert('Please login again');
        dispatch(setLogout());
        localStorage.removeItem(userData);
        navigate('/login');
    }

    else {
        if (errorHandler) {
            errorHandler(errorData);
        }
        else
            alert(errMessage);
    }


};
